export default __webpack_public_path__ + "d46dd9229074c4d35002242985c7bdf2.svg";